import { X } from 'lucide-react';
import React from 'react';

interface ConfirmationModalProps {
  isOpen: boolean;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void;
  onCancel: () => void;
  isDestructive?: boolean;
}

export const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  isOpen,
  title,
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  onConfirm,
  onCancel,
  isDestructive = false,
}) => {
  if (!isOpen) return null;

  return (
    <div data-testid="confirmation-modal" className="fixed inset-0 z-[70] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm animate-fade-in">
      <div className="bg-white rounded-3xl w-full max-w-sm overflow-hidden shadow-xl animate-scale-in">
        {/* Header */}
        <div className="p-4 border-b border-gray-100 flex items-center justify-between bg-brand-cream">
          <h3 className="font-display font-extrabold text-xl text-brand-dark">{title}</h3>
          <button 
            onClick={onCancel}
            className="p-2 hover:bg-black/5 rounded-full transition-colors"
          >
            <X size={20} className="text-brand-dark-light" />
          </button>
        </div>

        {/* Body */}
        <div className="p-6">
          <p className="text-brand-dark-light text-sm leading-relaxed">
            {message}
          </p>
        </div>

        {/* Footer */}
        <div className="p-4 bg-gray-50 flex gap-3">
          <button
            onClick={onCancel}
            className="flex-1 py-3 px-4 rounded-xl font-bold text-sm bg-white border border-gray-200 text-brand-dark hover:bg-gray-50 transition-colors"
          >
            {cancelText}
          </button>
          <button
            onClick={onConfirm}
            className={`flex-1 py-3 px-4 rounded-xl font-bold text-sm text-white shadow-lg transition-all active:scale-95 ${
              isDestructive 
                ? 'bg-brand-red shadow-brand-red/20 hover:bg-red-600' 
                : 'bg-brand-dark shadow-brand-dark/20 hover:bg-black'
            }`}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};
